addEventListener('DOMContentLoaded', _ => {
    Object.defineProperty(document, 'top', {
        get() {
            return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
        },
    })
    const navElement = document.querySelector('#primary-navigation')
    const nextSibling = navElement.parentElement.querySelector('#primary-navigation + *')
    const mirror = navElement.cloneNode(true)
    mirror.classList.add('mirror')
    navElement.parentElement.insertBefore(mirror, nextSibling)
    addEventListener('scroll', _ => {
        if (document.top > navElement.clientHeight) {
            navElement.classList.add('scrolled')
        } else {
            navElement.classList.remove('scrolled')
        }
    })

    const hamburger = document.querySelectorAll('.mobile-nav-toggle')
    const navItems = document.querySelector('#mobile-navigation-items')

    hamburger.forEach(element => {
        element.addEventListener('click', _ => {
            navItems.classList.toggle('open')
            element.classList.toggle('opened')
        })
    });

})
